import { inmunetApi } from '../../../api';

export const getEstadisticas = async(periodo, desde, hasta) => {

    const params = new URLSearchParams();
    params.append('periodo', `${periodo}`);
    params.append('desde', `${desde}`);
    params.append('hasta', `${hasta}`);

    try {

        const { data } = await inmunetApi.get(`estadisticas`, {
            params,
        });

        if (!data.status) throw (data.msg) ? data.msg : 'Error al obtener los datos';

        return data;

    } catch (error) {

        throw new Error('Error al obtener los datos');

    }

};